export default __webpack_public_path__ + "static/events-dark-mode-7517551b4507b29d7353b76db6758a17.png";